import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { UtilityService } from './utility.service';
import 'rxjs';
import { Subject } from 'rxjs';




@Injectable()
export class CalendarService {

      refresh = new Subject<void>();
    inviteClose = new Subject<void>();

    constructor(

    ) {

    }

    triggerRefresh() {
        this.refresh.next();
    }

    triggerInviteClose() {
        this.inviteClose.next();
    }


}
